import React, {ReactElement} from 'react'
import NatCondominiumRepo from './components/condominium/repository/NatCondominiumRepo'
import NatResidentUserRepo from './components/residentUser/repository/NatResidentUserRepo'
import NatRoomToResidentRepo from './components/roomToResident/repository/NatRoomToResidentRepo'
import NatCondominiumGroupRepo from './components/condominiumGroup/repository/NatCondominiumGroupRepo'
import NatRidgeRepo from './components/ridge/repository/NatRidgeRepo'
import NatPasswordRepo from './components/password/repository/NatPasswordRepo'
import NatMessageRepo from './components/message/repository/NatMessageRepo'
import NatCurrentDateTimeRepo from './components/currentDateTime/repository/NatCurrentDateTimeRepo'
import NatTokenRepo from './components/token/repository/NatTokenRepo'
import NatLoginRepo from './components/login/repository/NatLoginRepo'
import NatSessionRepo from './components/session/repository/NatSessionRepo'
import NatSsoRepo from './components/sso/repository/NatSsoRepo'
import NatResidentFirstLoginPolicyAgreePage from './components/firstLogin/NatResidentFirstLoginPolicyAgreePage'
import NatResidentFirstLoginAuthenticationKeyInputPage
    from './components/firstLogin/NatResidentFirstLoginAuthenticationKeyInputPage'
import NatResidentFirstLoginHasekoIdConfirmPage from './components/firstLogin/NatResidentFirstLoginHasekoIdConfirmPage'
import NatResidentFirstLoginMailAddressRegisterPage
    from './components/firstLogin/NatResidentFirstLoginMailAddressRegisterPage'
import NatResidentFirstLoginMailSendCompletePage
    from './components/firstLogin/NatResidentFirstLoginMailSendCompletePage'
import NatResidentFirstLoginUserInfoInputPage from './components/firstLogin/NatResidentFirstLoginUserInfoInputPage'
import NatResidentFirstLoginUserInfoConfirmPage from './components/firstLogin/NatResidentFirstLoginUserInfoConfirmPage'
import NatResidentFirstLoginUserInfoCompletePage
    from './components/firstLogin/NatResidentFirstLoginUserInfoCompletePage'
import NatResidentFirstLoginHasekoIdPasswordConfirmPage
    from './components/firstLogin/NatResidentFirstLoginHasekoIdPasswordConfirmPage'
import NatResidentFirstLoginSutekiPasswordConfirmPage
    from './components/firstLogin/NatResidentFirstLoginSutekiPasswordConfirmPage'
import NatResidentHasekoIdLinkCompletePage from './components/firstLogin/NatResidentHasekoIdLinkCompletePage'
import NatResidentPasswordResetMailAddressInputPage
    from './components/password/NatResidentPasswordResetMailAddressInputPage'
import NatResidentPasswordResetMailAddressCompletePage
    from './components/password/NatResidentPasswordResetMailAddressCompletePage'
import NatResidentPasswordResetInputPage from './components/password/NatResidentPasswordResetInputPage'
import NatResidentPasswordResetCompletePage from './components/password/NatResidentPasswordResetCompletePage'
import NatResidentChangeMailAddressPage from './components/mailAddress/NatResidentChangeMailAddressPage'
import NatResidentChangeMailAddressMailSendPage from './components/mailAddress/NatResidentChangeMailAddressMailSendPage'
import NatResidentChangeMailAddressCompletePage from './components/mailAddress/NatResidentChangeMailAddressCompletePage'
import NatResidentMailNoticeSettingPage from './components/personalSetting/NatResidentMailNoticeSettingPage'
import NatResidentChangeUserNamePage from './components/personalSetting/NatResidentChangeUserNamePage'

import NatResidentStaticContentsPage from './components/staticContents/NatResidentStaticContentsPage'
import NatResidentContactusPage from './components/contactus/NatResidentContactusPage'
import NatResidentPersonalSettingPage from './components/personalSetting/NatResidentPersonalSettingPage'
import NatResidentChangePasswordInputPage from './components/password/NatResidentChangePasswordInputPage'
import NatResidentChangePasswordCompletePage from './components/password/NatResidentChangePasswordCompletePage'
import NatResidentMessageListPage from './components/message/NatResidentMessageListPage'
import NatResidentMessagePage from './components/message/NatResidentMessagePage'
import NatResidentMypagePage from './components/mypage/NatResidentMypagePage'
import NatResidentLoginPage from './components/login/NatResidentLoginPage'
import NatResidentLoginRedirectPage from './components/login/NatResidentLoginRedirectPage'
import NatResidentSsoLoginPage from './components/sso/NatResidentSsoLoginPage'
import NatResidentSsoLoginRedirectPage from './components/sso/NatResidentSsoLoginRedirectPage'
import NatResidentCondominiumSelectPage from './components/condominium/NatResidentCondominiumSelectPage'
import NatLoginBeforeMessageRepo from './components/loginBeforeMessage/repository/NatLoginBeforeMessageRepo'
import NatMenuMasterRepo from './components/menuMaster/repository/NatMenuMasterRepo'
import NatLifeNoteRepo from './components/lifeNote/repository/NatLifeNoteRepo'
import NatResidentLifeNoteListPage from './components/lifeNote/NatResidentLifeNoteListPage'
import EventEmitterExResident from '../components/shared/pageBaseComponents/EventEmitterExResident'
import NatEventRepo from './components/event/repository/NatEventRepo'
import NatResidentCalendarPage from './components/calendar/NatResidentCalendarPage'
import NatHolidayMasterRepo from './components/holiday/repository/NatHolidayMasterRepo'
import NatResidentApartInfoPage from './components/apartAssocInfo/NatResidentApartInfoPage'
import NatApartAssocInfoRepo from './components/apartAssocInfo/repository/NatApartAssocInfoRepo'
import NatResidentAssocInfoPage from './components/apartAssocInfo/NatResidentAssocInfoPage'
import NatResidentSystemErrorPage from './components/error/NatResidentSystemErrorPage'
import ReservationsRepository from '../components/reservations/ReservationsRepository'
import NatFacilityReserveRepo from './components/facilityReserve/repository/NatFacilityReserveRepo'
import NatResidentBulletinBoardPage from './components/bulletinBoard/NatResidentBulletinBoardPage'
import NatBulletinBoardRepo from './components/bulletinBoard/repository/NatBulletinBoardRepo'
import NatResidentBulletinBoardThreadListPage from './components/bulletinBoard/NatResidentBulletinBoardThreadListPage'
import NatResidentBulletinBoardThreadPage from './components/bulletinBoard/NatResidentBulletinBoardThreadPage'
import NatResidentBulletinBoardThreadRegisterPage
    from './components/bulletinBoard/NatResidentBulletinBoardThreadRegisterPage'
import NatResidentBulletinBoardThreadConfirmPage
    from './components/bulletinBoard/NatResidentBulletinBoardThreadConfirmPage'
import NatResidentBulletinBoardThreadCommentRegisterPage
    from './components/bulletinBoard/NatResidentBulletinBoardThreadCommentRegisterPage'
import NatResidentBulletinBoardThreadCommentConfirmPage
    from './components/bulletinBoard/NatResidentBulletinBoardThreadCommentConfirmPage';
import NatEnvSettingRepo from './components/envSetting/repository/NatEnvSettingRepo';
import NatCommunicationPlatformRepo from './components/communicationPlatform/repository/NatCommunicationPlatformRepo';
import NatResidentCommunicationPlatformRegisterPage
    from './components/communicationPlatform/NatResidentCommunicationPlatformRegisterPage';
import NatResidentAdLoginPage from './components/login/NatResidentAdLoginPage'
import NatResidentAdSSOLoginRedirectPage from './components/sso/NatResidentAdSSOLoginRedirectPage'
import {MeetingRepositoryForResident} from '../components/assocDirector/MeetingRepositoryForResident'
import NatResidentContactAddressOnEmergencyAgreementPage
    from './components/applications/contactAddressOnEmergencies/NatResidentContactAddressOnEmergencyAgreementPage'
import NatResidentContactAddressOnEmergencyAgreementInputPage
    from './components/applications/contactAddressOnEmergencies/NatResidentContactAddressOnEmergencyInputPage'
import {NatApplicationRepo} from './components/applications/repository/NatApplicationRepo'
import NatResidentContactAddressOnEmergencyConfirmPage
    from './components/applications/contactAddressOnEmergencies/NatResidentContactAddressOnEmergencyConfirmPage'
import NatResidentApplicationCompletePage from './components/applications/common/NatResidentApplicationCompletePage'
import HolidaysRepository from '../components/HolidaysRepository'
import NatResidentBicycleParkingUseApplyAgreementPage
    from './components/applications/bicycleParkingUses/NatResidentBicycleParkingUseApplyAgreementPage'
import NatResidentBicycleParkingUseApplyInputPage
    from './components/applications/bicycleParkingUses/NatResidentBicycleParkingUseApplyInputPage'
import NatResidentBicycleParkingUseApplyConfirmPage
    from './components/applications/bicycleParkingUses/NatResidentBicycleParkingUseApplyConfirmPage'
import NatResidentParkingUsesAgreementPage
    from './components/applications/parkingUses/NatResidentParkingUsesAgreementPage'
import NatResidentParkingUsesInputPage from './components/applications/parkingUses/NatResidentParkingUsesInputPage'
import NatResidentParkingUsesConfirmPage from './components/applications/parkingUses/NatResidentParkingUsesConfirmPage'
import NatResidentParkingUsesChangeAgreementPage
    from './components/applications/parkingUsesChange/NatResidentParkingUsesChangeAgreementPage'
import NatResidentParkingUsesChangeInputPage
    from './components/applications/parkingUsesChange/NatResidentParkingUsesChangeInputPage'
import NatResidentParkingUsesChangeConfirmPage
    from './components/applications/parkingUsesChange/NatResidentParkingUsesChangeConfirmPage'
import NatResidentBikeParkingUseApplyAgreementPage
    from './components/applications/bikeParkingUses/NatResidentBikeParkingUseApplyAgreementPage'
import NatResidentBikeParkingUseApplyInputPage
    from './components/applications/bikeParkingUses/NatResidentBikeParkingUseApplyInputPage'
import NatResidentBikeParkingUseApplyConfirmPage
    from './components/applications/bikeParkingUses/NatResidentBikeParkingUseApplyConfirmPage'
import NatResidentPetBreedingApplyAgreementPage
    from './components/applications/petBreeding/NatResidentPetBreedingApplyAgreementPage'
import NatResidentPetBreedingApplyInputPage
    from './components/applications/petBreeding/NatResidentPetBreedingApplyInputPage'
import NatResidentPetBreedingApplyConfirmPage
    from './components/applications/petBreeding/NatResidentPetBreedingApplyConfirmPage'
import NatResidentApplicationPage from './components/applications/application/NatResidentApplicationPage'
import CondominiumsRepository from '../components/condominiums/CondominiumsRepository'
import NatResidentHasekoIdRegistrationPage from './components/residentUser/NatResidentHasekoIdRegistrationPage'
import NatResidentPetMedicalCheckUpReportAgreementPage
    from './components/applications/petMedicalCheckUpReport/NatResidentPetMedicalCheckUpReportAgreementPage'
import NatResidentPetMedicalCheckUpReportInputPage
    from './components/applications/petMedicalCheckUpReport/NatResidentPetMedicalCheckUpReportInputPage'
import NatResidentPetMedicalCheckUpReportConfirmPage
    from './components/applications/petMedicalCheckUpReport/NatResidentPetMedicalCheckUpReportConfirmPage'
import NatResidentBikeParkingUseChangeApplyAgreementPage
    from './components/applications/bikeParkingUsesChange/NatResidentBikeParkingUseChangeApplyAgreementPage'
import NatResidentBikeParkingUseChangeApplyInputPage
    from './components/applications/bikeParkingUsesChange/NatResidentBikeParkingUseChangeApplyInputPage'
import NatResidentBikeParkingUseChangeApplyConfirmPage
    from './components/applications/bikeParkingUsesChange/NatResidentBikeParkingUseChangeApplyConfirmPage'
import NatResidentConstructionAgreementPage
    from './components/applications/constructions/NatResidentConstructionAgreementPage'
import NatResidentConstructionApplyInputPage
    from './components/applications/constructions/NatResidentConstructionInputPage'
import NatResidentConstructionConfirmPage
    from './components/applications/constructions/NatResidentConstructionConfirmPage'
import NatResidentConstructionCompleteInputPage
    from './components/applications/constructionComplete/NatResidentConstructionCompleteInputPage'
import NatResidentConstructionCompleteConfirmPage
    from './components/applications/constructionComplete/NatResidentConstructionCompleteConfirmPage'
import NatResidentBicycleParkingUseWithdrawalInputPage
    from './components/applications/bicycleParkingUseWithdrawal/NatResidentBicycleParkingUseWithdrawalInputPage'
import NatResidentBicycleParkingUseWithdrawalConfirmPage
    from './components/applications/bicycleParkingUseWithdrawal/NatResidentBicycleParkingUseWithdrawalConfirmPage'
import NatResidentPetBreedingStopInputPage
    from './components/applications/petBreedingStop/NatResidentPetBreedingStopInputPage'
import NatResidentPetBreedingStopConfirmPage
    from './components/applications/petBreedingStop/NatResidentPetBreedingStopConfirmPage'
import NatResidentParkingUsesWithdrawalInputPage
    from './components/applications/parkingUsesWithdrawal/NatResidentParkingUsesWithdrawalInputPage'
import NatResidentParkingUsesWithdrawalConfirmPage
    from './components/applications/parkingUsesWithdrawal/NatResidentParkingUsesWithdrawalConfirmPage'
import NatResidentParkingUsesPage from './components/applications/parkingUses/NatResidentParkingUsesPage'
import NatResidentBikeParkingUseWithdrawalApplyInputPage
    from './components/applications/bikeParkingUsesWithdrawal/NatResidentBikeParkingUseWithdrawalApplyInputPage'
import NatResidentBikeParkingUseWithdrawalApplyConfirmPage
    from './components/applications/bikeParkingUsesWithdrawal/NatResidentBikeParkingUseWithdrawalApplyConfirmPage'
import NatResidentPetBreedingPage from './components/applications/petBreeding/NatResidentPetBreedingPage'
import NatResidentPetMedicalCheckUpReportPage
    from './components/applications/petMedicalCheckUpReport/NatResidentPetMedicalCheckUpReportPage'
import NatResidentPetBreedingStopPage from './components/applications/petBreedingStop/NatResidentPetBreedingStopPage'
import {NatFileRepo} from './components/files/repository/NatFileRepo'
import NatResidentBrowseAgreementPage from './components/applications/browses/NatResidentBrowseAgreementPage'
import NatResidentBrowseApplyInputPage from './components/applications/browses/NatResidentBrowseInputPage'
import NatResidentBrowseConfirmPage from './components/applications/browses/NatResidentBrowseConfirmPage'
import NatResidentAssociationSelectionPage
    from './components/assocWorkReports/assocWorkReport/NatResidentAssociationSelectionPage'
import NatResidentAssocWorkReportPage
    from './components/assocWorkReports/assocWorkReport/NatResidentAssocWorkReportPage'
import {NatAssocWorkReportRepo} from './components/assocWorkReports/repository/NatAssocWorkReportRepo'
import NatResidentAccountTransferRedirectPage from './components/accountTransfer/NatResidentAccountTransferRedirectPage'
import NatResidentWindowFilmAttachAgreementPage
    from './components/applications/windowFilmAttaches/NatResidentWindowFilmAttachAgreementPage'
import NatResidentWindowFilmAttachConfirmPage
    from './components/applications/windowFilmAttaches/NatResidentWindowFilmAttachConfirmPage'
import NatResidentWindowFilmAttachInputPage
    from './components/applications/windowFilmAttaches/NatResidentWindowFilmAttachInputPage'
import NatApplyHistoryListPage from './components/applications/history/NatApplyHistoryListPage'
import NatResidentLongAbsenceInputPage from './components/applications/longAbsence/NatResidentLongAbsenceInputPage'
import NatResidentLongAbsenceConfirmPage from './components/applications/longAbsence/NatResidentLongAbsenceConfirmPage'
import NatResidentHeavyLoadsCarryAgreementPage
    from './components/applications/heavyLoadsCarries/NatResidentHeavyLoadsCarryAgreementPage'
import NatResidentHeavyLoadsCarryInputPage
    from './components/applications/heavyLoadsCarries/NatResidentHeavyLoadsCarryInputPage'
import NatResidentHeavyLoadsCarryConfirmPage
    from './components/applications/heavyLoadsCarries/NatResidentHeavyLoadsCarryConfirmPage'
import NatResidentContactAddressOnEmergencyPage
    from './components/applications/contactAddressOnEmergencies/NatResidentContactAddressOnEmergencyPage'
import NatResidentParkingUsesChangePage
    from './components/applications/parkingUsesChange/NatResidentParkingUsesChangePage'
import NatResidentParkingUsesWithdrawalPage
    from './components/applications/parkingUsesWithdrawal/NatResidentParkingUsesWithdrawalPage'
import NatResidentBicycleParkingUsesWithdrawalPage
    from './components/applications/bicycleParkingUseWithdrawal/NatResidentBicycleParkingUseWithdrawalPage'
import NatResidentBikeParkingUsesPage from './components/applications/bikeParkingUses/NatResidentBikeParkingUsesPage'
import NatResidentBikeParkingUsesChangePage
    from './components/applications/bikeParkingUsesChange/NatResidentBikeParkingUseChangePage'
import NatResidentBikeParkingUsesWithdrawalPage
    from './components/applications/bikeParkingUsesWithdrawal/NatResidentBikeParkingUseWithdrawalPage'
import NatResidentBicycleParkingUsesPage
    from './components/applications/bicycleParkingUses/NatResidentBicycleParkingUsePage'
import NatResidentConstructionPage from './components/applications/constructions/NatResidentConstructionPage'
import NatResidentConstructionCompletePage
    from './components/applications/constructionComplete/NatResidentConstructionCompletePage'
import NatResidentBrowsePage from './components/applications/browses/NatResidentBrowsePage'
import NatResidentLongAbsencePage from './components/applications/longAbsence/NatResidentLongAbsencePage'
import NatResidentHeavyLoadsCarryPage from './components/applications/heavyLoadsCarries/NatResidentHeavyLoadsCarryPage'
import NatResidentWindowFilmAttachPage
    from './components/applications/windowFilmAttaches/NatResidentWindowFilmAttachPage'
import NatResidentExternalTransmissionPage from './components/externalTransmission/NatResidentExternalTransmissionPage'
import NatResidentNotFoundErrorPage from './components/error/NatResidentNotFoundErrorPage'
import {NatOwnershipTransfersRepo} from './components/ownershipTransfers/repository/NatOwnershipTransfersRepo'
import NatCampaignRepo from './components/campaigns/repository/NatCampainRepo';
import {Route} from 'react-router-dom'
import RouterPropsInjector from '../components/shared/RouterPropsInjector'
import NatResidentUserRegistrationAgreementPage
    from './components/applications/residentUserRegistration/NatResidentUserRegistrationAgreementPage'
import NatResidentCondominiumRegisterPage
    from './components/applications/residentUserRegistration/NatResidentCondominiumRegisterPage'
import NatResidentUserRegistrationMailSendCompletePage
    from './components/applications/residentUserRegistration/NatResidentUserRegistrationMailSendCompletePage'
import NatResidentNoAuthenticationKeyCompletePage
    from './components/applications/residentUserRegistration/NatResidentUserRegistrationCompletePage'
import NatResidentNoAuthenticationKeyInputPage
    from './components/applications/residentUserRegistration/NatResidentUserRegistrationInputPage'
import NatResidentUserRegistrationConfirmPage
    from './components/applications/residentUserRegistration/NatResidentUserRegistrationConfirmPage'
import NatResidentAfterLoginCushion from './components/login/NatResidentAfterLoginCushion';
import AdminAuthRepository from './components/login/repository/AdminAuthRepository';
import NatResidentUserDetailPage from './components/personalSetting/NatResidentUserDetailPage'
import NatAuthorityRepo from './components/authority/repository/NatAuthorityRepo';
import NatResidentUserUseRestrictionSettingPage
    from './components/personalSetting/NatResidentUserUseRestrictionSettingPage';
import NatResidentBankAccountInfoRepo from './components/accountTransfer/repository/NatResidentBankAccountInfoRepo'
import NatResidentBankAccountInfoPage from './components/accountTransfer/NatResidentBankAccountInfoPage'
import NatResidentAccountTransferPage from './components/accountTransfer/NatResidentAccountTransferPage'
import NatResidentSubResidentUserAddPage from './components/personalSetting/NatResidentSubResidentUserAddPage';
import NatResidentUserListPage from './components/personalSetting/NatResidentUserManagePage';
import NatAmountFixRepo from './components/AmountFix/repository/NatAmountFixRepo';
import NatResidentBillingAmountConfirmPage from './components/AmountFix/NatResidentBillingAmountConfirmPage'
import NatResidentReceiptIssuePage from './components/AmountFix/NatResidentReceiptIssuePage'
import NatUseFunctionMasterRepo from './components/useFunctionMaster/repository/NatUseFunctionMasterRepo';
import NatSutekiNetPlusRepo from './components/mypage/repository/NatSutekiNetPlusRepo';
import NatDisasterRepo from './components/disaster/repository/NatDisasterRepo';
import NatResidentDisasterPreventionPage from './components/disaster/NatResidentDisasterPreventionPage';
import NatResidentDisasterTopicListPage from './components/disaster/NatResidentDisasterTopicListPage';
import NatResidentDisasterModeSettingPage from './components/disaster/NatResidentDisasterModeSettingPage'
import NatResidentDisasterModeReleaseExtensionPage
    from './components/disaster/NatResidentDisasterModeReleaseExtensionPage'
import NatResidentDisasterModeSetupCompletePage from './components/disaster/NatResidentDisasterModeSetupCompletePage';
import NatResidentDisasterTopicRegisterPage from './components/disaster/NatResidentDisasterTopicRegisterPage';
import NatResidentDisasterTopicPage from './components/disaster/NatResidentDisasterTopicPage'
import NatResidentDisasterTopicEditPage from './components/disaster/NatResidentDisasterTopicEditPage';
import NatResidentDisasterPreventionsPage from './components/disaster/NatResidentDisasterPreventionsPage'
import NatResidentDisasterPreventionsDetailsPage from './components/disaster/NatResidentDisasterPreventionsDetailsPage'
import ResidentUnitOwnerConfirmationErrorPage from '../components/generalMeeting/ResidentUnitOwnerConfirmationErrorPage'
import ResidentGeneralMeetingRepo from '../components/generalMeeting/ResidentGeneralMeetingRepo'
import NatAdminUserRepo from './components/adminUser/repository/NatAdminUserRepo'

interface Props {
    eventEmitter: EventEmitterExResident
    tokenRepo: NatTokenRepo
    condominiumRepo: NatCondominiumRepo
    condominiumsRepo: CondominiumsRepository
    adminUserRepo: NatAdminUserRepo
    residentUserRepo: NatResidentUserRepo
    roomToResidentRepo: NatRoomToResidentRepo
    condominiumGroupRepo: NatCondominiumGroupRepo
    ridgeRepo: NatRidgeRepo
    passwordRepo: NatPasswordRepo
    messageRepo: NatMessageRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    residentLoginRepo: NatLoginRepo
    sessionRepo: NatSessionRepo
    loginBeforeMessageRepo: NatLoginBeforeMessageRepo
    menuMasterRepo: NatMenuMasterRepo
    lifeNoteRepo: NatLifeNoteRepo
    eventRepo: NatEventRepo
    holidayMasterRepo: NatHolidayMasterRepo
    apartAssocInfoRepo: NatApartAssocInfoRepo
    reservationsRepo: ReservationsRepository
    facilityReserveRepo: NatFacilityReserveRepo
    bulletinBoardRepo: NatBulletinBoardRepo
    envSettingRepo: NatEnvSettingRepo
    ssoRepo: NatSsoRepo
    communicationPlatformRepo: NatCommunicationPlatformRepo
    meetingRepo: MeetingRepositoryForResident
    applicationRepo: NatApplicationRepo
    holidaysRepo: HolidaysRepository
    fileRepo: NatFileRepo
    assocWorkReportRepo: NatAssocWorkReportRepo
    ownershipTransfersRepo: NatOwnershipTransfersRepo
    campaignRepo: NatCampaignRepo
    adminAuthRepo: AdminAuthRepository
    authorityRepo: NatAuthorityRepo
    bankAccountInfoRepo: NatResidentBankAccountInfoRepo
    amountFixRepo: NatAmountFixRepo
    useFunctionMasterRepo: NatUseFunctionMasterRepo
    sutekiNetPlusRepo: NatSutekiNetPlusRepo
    disasterRepo: NatDisasterRepo
    residentGeneralMeetingRepo: ResidentGeneralMeetingRepo
}

export function SubRoutesResident(routesProps: Props): ReactElement {
    const {
        eventEmitter,
        tokenRepo,
        condominiumRepo,
        condominiumsRepo,
        adminUserRepo,
        residentUserRepo,
        roomToResidentRepo,
        condominiumGroupRepo,
        ridgeRepo,
        passwordRepo,
        messageRepo,
        currentDateTimeRepo,
        residentLoginRepo,
        sessionRepo,
        loginBeforeMessageRepo,
        menuMasterRepo,
        lifeNoteRepo,
        eventRepo,
        holidayMasterRepo,
        apartAssocInfoRepo,
        reservationsRepo,
        facilityReserveRepo,
        bulletinBoardRepo,
        envSettingRepo,
        ssoRepo,
        communicationPlatformRepo,
        meetingRepo,
        applicationRepo,
        holidaysRepo,
        fileRepo,
        assocWorkReportRepo,
        ownershipTransfersRepo,
        campaignRepo,
        adminAuthRepo,
        authorityRepo,
        bankAccountInfoRepo,
        amountFixRepo,
        useFunctionMasterRepo,
        sutekiNetPlusRepo,
        disasterRepo,
        residentGeneralMeetingRepo,
    }: Props = routesProps
    return (<>
        <Route
            path="/resident/error"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentSystemErrorPage
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'システムエラー | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/not-found"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentNotFoundErrorPage
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'Not Foundエラー | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/general-meeting/error"
            element={<RouterPropsInjector>{(props) =>
                <ResidentUnitOwnerConfirmationErrorPage
                    navigate={props.navigate}
                    eventEmitter={eventEmitter}
                    pageTitle={'区分所有者確認エラー | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/login"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentLoginPage
                    navigate={props.navigate}
                    residentLoginRepo={residentLoginRepo}
                    loginBeforeMessageRepo={loginBeforeMessageRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    location={props.location}
                    sessionRepo={sessionRepo}
                    eventEmitter={eventEmitter}
                    residentUserRepo={residentUserRepo}
                    pageTitle={'ログイン | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/adLogin"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentAdLoginPage
                    navigate={props.navigate}
                    location={props.location}
                    residentLoginRepo={residentLoginRepo}
                    sessionRepo={sessionRepo}
                    eventEmitter={eventEmitter}
                    pageTitle={'長谷工グループ認証 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/sso/azure/redirect"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentAdSSOLoginRedirectPage
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'長谷工グループ認証リダイレクト | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/loginRedirect"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentLoginRedirectPage
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'ログインリダイレクト | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/external/reception"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentSsoLoginPage
                    navigate={props.navigate}
                    location={props.location}
                    envSettingRepo={envSettingRepo}
                    sessionRepo={sessionRepo}
                    residentLoginRepo={residentLoginRepo}
                    eventEmitter={eventEmitter}
                    residentUserRepo={residentUserRepo}
                    pageTitle={'SSO認証受付画面 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/ssoLoginRedirect"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentSsoLoginRedirectPage
                    navigate={props.navigate}
                    ssoRepo={ssoRepo}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'SSO認証後リダイレクト画面 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiumSelect"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentCondominiumSelectPage
                    condominiumRepo={condominiumRepo}
                    sessionRepo={sessionRepo}
                    condominiumGroupRepo={condominiumGroupRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'物件選択 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/firstLoginPolicyAgree"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentFirstLoginPolicyAgreePage
                    tokenRepo={tokenRepo}
                    ownershipTransfersRepo={ownershipTransfersRepo}
                    roomToResidentRepo={roomToResidentRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'初回ログイン利用規約 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/firstLoginAuthenticationKeyInput"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentFirstLoginAuthenticationKeyInputPage
                    roomToResidentRepo={roomToResidentRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'初回ログイン認証キー入力 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/firstLoginHasekoIdConfirm"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentFirstLoginHasekoIdConfirmPage
                    residentUserRepo={residentUserRepo}
                    roomToResidentRepo={roomToResidentRepo}
                    tokenRepo={tokenRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'初回ログイン長谷工ID確認 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/firstLoginMailAddressRegister"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentFirstLoginMailAddressRegisterPage
                    tokenRepo={tokenRepo}
                    roomToResidentRepo={roomToResidentRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'初回ログインメールアドレス登録 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/firstLoginMailSendComplete"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentFirstLoginMailSendCompletePage
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'初回ログインメール送信完了 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/firstLoginUserInfoInput"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentFirstLoginUserInfoInputPage
                    residentUserRepo={residentUserRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    tokenRepo={tokenRepo}
                    roomToResidentRepo={roomToResidentRepo}
                    ownershipTransfersRepo={ownershipTransfersRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'初回ログインユーザ情報入力 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/firstLoginUserInfoConfirm"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentFirstLoginUserInfoConfirmPage
                    residentUserRepo={residentUserRepo}
                    tokenRepo={tokenRepo}
                    roomToResidentRepo={roomToResidentRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'初回ログインユーザ情報確認 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/hasekoIdRegistration"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentHasekoIdRegistrationPage
                    residentUserRepo={residentUserRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'長谷工ID登録 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/firstLoginUserInfoRegisterComplete"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentFirstLoginUserInfoCompletePage
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'初回ログインユーザ情報登録完了 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/firstLoginHasekoIdPasswordConfirm"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentFirstLoginHasekoIdPasswordConfirmPage
                    residentUserRepo={residentUserRepo}
                    roomToResidentRepo={roomToResidentRepo}
                    tokenRepo={tokenRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'初回ログイン長谷工IDパスワード確認 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/firstLoginSutekiPasswordConfirm"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentFirstLoginSutekiPasswordConfirmPage
                    residentUserRepo={residentUserRepo}
                    roomToResidentRepo={roomToResidentRepo}
                    tokenRepo={tokenRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'初回ログイン素敵ネットパスワード確認 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/hasekoIdLinkComplete"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentHasekoIdLinkCompletePage
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'長谷工ID連携完了 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/personalSetting"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentPersonalSettingPage
                    residentUserRepo={residentUserRepo}
                    residentGeneralMeetingRepo={residentGeneralMeetingRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'個人設定 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/changePasswordInput"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentChangePasswordInputPage
                    passwordRepo={passwordRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'パスワード変更入力 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/changePasswordComplete"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentChangePasswordCompletePage
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'パスワード変更完了 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/passwordResetMailAddressInput"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentPasswordResetMailAddressInputPage
                    tokenRepo={tokenRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'パスワード再設定メール送信 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/passwordResetMailAddressComplete"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentPasswordResetMailAddressCompletePage
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'パスワード再設定メール送信完了 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/passwordResetInput"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentPasswordResetInputPage
                    residentUserRepo={residentUserRepo}
                    tokenRepo={tokenRepo}
                    passwordRepo={passwordRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'パスワード再設定入力 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/passwordResetComplete"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentPasswordResetCompletePage
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'パスワード再設定完了 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/changeMailAddress"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentChangeMailAddressPage
                    tokenRepo={tokenRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'メールアドレス変更 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/changeMailAddressMailSend"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentChangeMailAddressMailSendPage
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'メールアドレス変更メール送信完了 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/changeMailAddressComplete"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentChangeMailAddressCompletePage
                    tokenRepo={tokenRepo}
                    residentUserRepo={residentUserRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'メールアドレス変更完了 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/mailNoticeSetting"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentMailNoticeSettingPage
                    residentUserRepo={residentUserRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'個人設定(メール通知設定) | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/changeUserName"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentChangeUserNamePage
                    residentUserRepo={residentUserRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'個人設定(氏名変更) | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/ridges/:ridgeCd/rooms/:roomNumber/subUsers/add"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentSubResidentUserAddPage
                    residentUserRepo={residentUserRepo}
                    tokenRepo={tokenRepo}
                    roomToResidentRepo={roomToResidentRepo}
                    condominiumCd={props.params.condominiumCd!}
                    ridgeCd={props.params.ridgeCd!}
                    roomNumber={props.params.roomNumber!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'個人設定(サブユーザ追加)  | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/ridges/:ridgeCd/rooms/:roomNumber/users/:seq/authority"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentUserUseRestrictionSettingPage
                    authorityRepo={authorityRepo}
                    condominiumCd={props.params.condominiumCd!}
                    ridgeCd={props.params.ridgeCd!}
                    roomNumber={props.params.roomNumber!}
                    seq={Number(props.params.seq!)}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'個人設定(利用制限の設定) | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/ridges/:ridgeCd/rooms/:roomNumber/users"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentUserListPage
                    condominiumCd={props.params.condominiumCd!}
                    ridgeCd={props.params.ridgeCd!}
                    roomNumber={props.params.roomNumber!}
                    residentUserRepo={residentUserRepo}
                    residentGeneralMeetingRepo={residentGeneralMeetingRepo}
                    tokenRepo={tokenRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'個人設定(ユーザ管理) | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/contents/:contents"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentStaticContentsPage
                    contents={props.params.contents!}
                    navigate={props.navigate}
                />
            }</RouterPropsInjector>}
        />

        <Route
            path="/resident/condominiums/:condominiumCd/ridges/:ridgeCd/rooms/:roomNumber/users/:seq"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentUserDetailPage
                    condominiumCd={props.params.condominiumCd!}
                    ridgeCd={props.params.ridgeCd!}
                    roomNumber={props.params.roomNumber!}
                    seq={Number(props.params.seq!)}
                    residentUserRepo={residentUserRepo}
                    roomToResidentRepo={roomToResidentRepo}
                    residentGeneralMeetingRepo={residentGeneralMeetingRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'個人設定(ユーザ詳細) | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/contactus"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentContactusPage
                    residentUserRepo={residentUserRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'お問い合わせ | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/externalTransmission"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentExternalTransmissionPage
                    residentUserRepo={residentUserRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'利用者情報の外部送信 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/messageList"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentMessageListPage
                    messageRepo={messageRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'メッセージ一覧 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/message/:messageId"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentMessagePage
                    messageId={props.params.messageId!}
                    messageRepo={messageRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'メッセージ詳細 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/mypage"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentMypagePage
                    residentUserRepo={residentUserRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    messageRepo={messageRepo}
                    reservationsRepo={reservationsRepo}
                    facilityReserveRepo={facilityReserveRepo}
                    meetingRepo={meetingRepo}
                    navigate={props.navigate}
                    applicationRepo={applicationRepo}
                    location={props.location}
                    campaignRepo={campaignRepo}
                    sutekiNetPlusRepo={sutekiNetPlusRepo}
                    amountFixRepo={amountFixRepo}
                    residentGeneralMeetingRepo={residentGeneralMeetingRepo}
                    eventEmitter={eventEmitter}
                    pageTitle={'素敵ネットTOP | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/lifeNote"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentLifeNoteListPage
                    lifeNoteRepo={lifeNoteRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'生活便利帳参照 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/calendar"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentCalendarPage
                    eventRepo={eventRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    holidayMasterRepo={holidayMasterRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'カレンダー詳細 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/apartInfoList"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentApartInfoPage
                    apartAssocInfoRepo={apartAssocInfoRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    tokenRepo={tokenRepo}
                    roomToResidentRepo={roomToResidentRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'マンション情報 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/assocInfoList"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentAssocInfoPage
                    apartAssocInfoRepo={apartAssocInfoRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    tokenRepo={tokenRepo}
                    roomToResidentRepo={roomToResidentRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'管理組合情報 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/bulletinBoard"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentBulletinBoardPage
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'情報交換掲示板カテゴリ選択 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/bulletinBoardThreadList/:categoryId"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentBulletinBoardThreadListPage
                    categoryId={props.params.categoryId!}
                    bulletinBoardRepo={bulletinBoardRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'情報交換掲示板スレッド一覧 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/bulletinBoardThread/:threadId"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentBulletinBoardThreadPage
                    threadId={Number(props.params.threadId!)}
                    bulletinBoardRepo={bulletinBoardRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'情報交換掲示板スレッド参照 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/bulletinBoardThreadRegister/:categoryId"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentBulletinBoardThreadRegisterPage
                    categoryId={props.params.categoryId!}
                    bulletinBoardRepo={bulletinBoardRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'情報交換掲示板新規スレッド登録 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/bulletinBoardThreadConfirm"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentBulletinBoardThreadConfirmPage
                    bulletinBoardRepo={bulletinBoardRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'情報交換掲示板新規スレッド登録確認 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/bulletinBoardThreadCommentRegister/:threadCategoryId/:threadId"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentBulletinBoardThreadCommentRegisterPage
                    threadCategoryId={props.params.threadCategoryId!}
                    threadId={props.params.threadId!}
                    bulletinBoardRepo={bulletinBoardRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'情報交換掲示板新規コメント登録 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/bulletinBoardThreadCommentConfirm/:threadCategoryId/:threadId"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentBulletinBoardThreadCommentConfirmPage
                    threadCategoryId={props.params.threadCategoryId!}
                    threadId={props.params.threadId!}
                    bulletinBoardRepo={bulletinBoardRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'情報交換掲示板新規コメント登録確認 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/communicationPlatform"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentCommunicationPlatformRegisterPage
                    communicationPlatformRepo={communicationPlatformRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'コミュニケーションプラットフォーム利用登録 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentApplicationPage
                    applicationRepo={applicationRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'届出・申請一覧 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/history"
            element={<RouterPropsInjector>{(props) =>
                <NatApplyHistoryListPage
                    applicationRepo={applicationRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'申請履歴一覧 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/contactAddressOnEmergencies/agreement"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentContactAddressOnEmergencyAgreementPage
                    applicationRepo={applicationRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'緊急時連絡表_誓約同意 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/contactAddressOnEmergencies/input"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentContactAddressOnEmergencyAgreementInputPage
                    applicationRepo={applicationRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    holidaysRepo={holidaysRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'緊急時連絡表_申請内容入力 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/contactAddressOnEmergencies/confirm"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentContactAddressOnEmergencyConfirmPage
                    applicationRepo={applicationRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'緊急時連絡表_申請内容確認 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/contactAddressOnEmergencies/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentContactAddressOnEmergencyPage
                    applicationRepo={applicationRepo}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'緊急時連絡表_申請履歴詳細 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/contactAddressOnEmergencies/:applyId/copy"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentContactAddressOnEmergencyAgreementPage
                    applicationRepo={applicationRepo}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'緊急時連絡表_誓約同意 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route

            path="/resident/condominiums/:condominiumCd/applications/bicycleParkingUses/agreement"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentBicycleParkingUseApplyAgreementPage
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'駐輪場使用申込_誓約同意 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/bicycleParkingUses/input"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentBicycleParkingUseApplyInputPage
                    applicationRepo={applicationRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    holidaysRepo={holidaysRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'駐輪場使用申込_申請内容入力 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/bicycleParkingUses/confirm"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentBicycleParkingUseApplyConfirmPage
                    applicationRepo={applicationRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'駐輪場使用申込_申請内容確認 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/bicycleParkingUses/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentBicycleParkingUsesPage
                    applicationRepo={applicationRepo}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'駐輪場使用申込_申請履歴詳細 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/bicycleParkingUses/:applyId/copy"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentBicycleParkingUseApplyAgreementPage
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'駐輪場使用申込_誓約同意 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/parkingUses/agreement"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentParkingUsesAgreementPage
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'駐車場使用申込_誓約同意 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/parkingUses/input"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentParkingUsesInputPage
                    applicationRepo={applicationRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    holidaysRepo={holidaysRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'駐車場使用申込_申請内容入力 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/parkingUses/confirm"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentParkingUsesConfirmPage
                    applicationRepo={applicationRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'駐車場使用申込_申請内容確認 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/parkingUses/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentParkingUsesPage
                    applicationRepo={applicationRepo}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'駐車場使用申込_申請履歴詳細 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/parkingUses/:applyId/copy"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentParkingUsesAgreementPage
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'駐車場使用申込_誓約同意 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/parkingUsesChange/agreement"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentParkingUsesChangeAgreementPage
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'自動車変更届_誓約同意 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/parkingUsesChange/input"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentParkingUsesChangeInputPage
                    applicationRepo={applicationRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    holidaysRepo={holidaysRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'自動車変更届_申請内容入力 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/parkingUsesChange/confirm"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentParkingUsesChangeConfirmPage
                    applicationRepo={applicationRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'自動車変更届_申請内容確認 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/parkingUsesChange/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentParkingUsesChangePage
                    applicationRepo={applicationRepo}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'自動車変更届_申請履歴詳細 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/parkingUsesChange/:applyId/copy"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentParkingUsesChangeAgreementPage
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'自動車変更届_誓約同意 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/bicycleParkingUsesWithdrawal/input"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentBicycleParkingUseWithdrawalInputPage
                    applicationRepo={applicationRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    holidaysRepo={holidaysRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'駐輪場使用許可解除申込_申請内容入力 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/bicycleParkingUsesWithdrawal/confirm"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentBicycleParkingUseWithdrawalConfirmPage
                    applicationRepo={applicationRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'駐輪場使用許可解除申込_申請内容確認 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/bicycleParkingUsesWithdrawal/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentBicycleParkingUsesWithdrawalPage
                    applicationRepo={applicationRepo}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'駐輪場使用許可解除申込_申請履歴詳細 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route

            path="/resident/condominiums/:condominiumCd/applications/bicycleParkingUsesWithdrawal/:applyId/copy"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentBicycleParkingUseWithdrawalInputPage
                    applicationRepo={applicationRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    holidaysRepo={holidaysRepo}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'駐輪場使用許可解除申込_申請内容入力 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/parkingUsesWithdrawal/input"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentParkingUsesWithdrawalInputPage
                    applicationRepo={applicationRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    holidaysRepo={holidaysRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'駐車場使用契約解約届_申請内容入力 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/parkingUsesWithdrawal/confirm"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentParkingUsesWithdrawalConfirmPage
                    applicationRepo={applicationRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'駐車場使用契約解約届_申請内容確認 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/parkingUsesWithdrawal/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentParkingUsesWithdrawalPage
                    applicationRepo={applicationRepo}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'駐車場使用契約解約届_申請履歴詳細 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/parkingUsesWithdrawal/:applyId/copy"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentParkingUsesWithdrawalInputPage
                    applicationRepo={applicationRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    holidaysRepo={holidaysRepo}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'駐車場使用契約解約届_申請内容入力 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/bikeParkingUses/agreement"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentBikeParkingUseApplyAgreementPage
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'バイク置場使用申込_誓約同意 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/bikeParkingUses/input"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentBikeParkingUseApplyInputPage
                    applicationRepo={applicationRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    holidaysRepo={holidaysRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'バイク置場使用申込_申請内容入力 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/bikeParkingUses/confirm"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentBikeParkingUseApplyConfirmPage
                    applicationRepo={applicationRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'バイク置場使用申込_申請内容確認 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/bikeParkingUses/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentBikeParkingUsesPage
                    applicationRepo={applicationRepo}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'バイク置場使用申込_申請履歴詳細 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/bikeParkingUses/:applyId/copy"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentBikeParkingUseApplyAgreementPage
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'バイク置場使用申込_誓約同意 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/bikeParkingUsesChange/agreement"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentBikeParkingUseChangeApplyAgreementPage
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'バイク変更届_誓約同意 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/bikeParkingUsesChange/input"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentBikeParkingUseChangeApplyInputPage
                    applicationRepo={applicationRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    holidaysRepo={holidaysRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'バイク変更届_申請内容入力 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/bikeParkingUsesChange/confirm"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentBikeParkingUseChangeApplyConfirmPage
                    applicationRepo={applicationRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'バイク変更届_申請内容確認 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/bikeParkingUsesChange/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentBikeParkingUsesChangePage
                    applicationRepo={applicationRepo}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'バイク変更届_申請履歴詳細 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/bikeParkingUsesChange/:applyId/copy"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentBikeParkingUseChangeApplyAgreementPage
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'バイク変更届_誓約同意 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/bikeParkingUsesWithdrawal/input"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentBikeParkingUseWithdrawalApplyInputPage
                    applicationRepo={applicationRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    holidaysRepo={holidaysRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'バイク置場使用契約解約届_申請内容入力 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/bikeParkingUsesWithdrawal/confirm"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentBikeParkingUseWithdrawalApplyConfirmPage
                    applicationRepo={applicationRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'バイク置場使用契約解約届_申請内容確認 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/bikeParkingUsesWithdrawal/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentBikeParkingUsesWithdrawalPage
                    applicationRepo={applicationRepo}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'バイク置場使用契約解約届_申請履歴詳細 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/bikeParkingUsesWithdrawal/:applyId/copy"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentBikeParkingUseWithdrawalApplyInputPage
                    applicationRepo={applicationRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    holidaysRepo={holidaysRepo}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'バイク置場使用契約解約届_申請内容入力 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/petBreeding/agreement"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentPetBreedingApplyAgreementPage
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'ペット飼育申請_誓約同意 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/petBreeding/input"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentPetBreedingApplyInputPage
                    applicationRepo={applicationRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    holidaysRepo={holidaysRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'ペット飼育申請_申請内容入力 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/petBreeding/confirm"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentPetBreedingApplyConfirmPage
                    applicationRepo={applicationRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'ペット飼育申請_申請内容確認 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/petBreeding/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentPetBreedingPage
                    applicationRepo={applicationRepo}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'ペット飼育申請_申請履歴詳細 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/petBreeding/:applyId/copy"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentPetBreedingApplyAgreementPage
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'ペット飼育申請_誓約同意 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/petMedicalCheckUpReport/agreement"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentPetMedicalCheckUpReportAgreementPage
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'健康診断報告書_誓約同意 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/petMedicalCheckUpReport/input"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentPetMedicalCheckUpReportInputPage
                    applicationRepo={applicationRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'健康診断報告書_申請内容入力 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/petMedicalCheckUpReport/confirm"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentPetMedicalCheckUpReportConfirmPage
                    applicationRepo={applicationRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'健康診断報告書_申請内容確認 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/petMedicalCheckUpReport/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentPetMedicalCheckUpReportPage
                    applicationRepo={applicationRepo}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'健康診断報告書_申請履歴詳細 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/petMedicalCheckUpReport/:applyId/copy"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentPetMedicalCheckUpReportAgreementPage
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'健康診断報告書_誓約同意 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/petBreedingStop/input"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentPetBreedingStopInputPage
                    applicationRepo={applicationRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    holidaysRepo={holidaysRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'ペット飼育中止届_申請内容入力 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/petBreedingStop/confirm"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentPetBreedingStopConfirmPage
                    applicationRepo={applicationRepo}
                    condominiumRepo={condominiumRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'ペット飼育中止届_申請内容確認 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/petBreedingStop/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentPetBreedingStopPage
                    applicationRepo={applicationRepo}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'ペット飼育中止届_申請履歴詳細 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/petBreedingStop/:applyId/copy"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentPetBreedingStopInputPage
                    applicationRepo={applicationRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    holidaysRepo={holidaysRepo}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'ペット飼育中止届_申請内容入力 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/constructions/agreement"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentConstructionAgreementPage
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'工事申請書_誓約同意 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/constructions/input"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentConstructionApplyInputPage
                    applicationRepo={applicationRepo}
                    fileRepo={fileRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    holidaysRepo={holidaysRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'工事申請書_申請内容入力 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/constructions/confirm"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentConstructionConfirmPage
                    applicationRepo={applicationRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'工事申請書_申請内容確認 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/constructions/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentConstructionPage
                    applicationRepo={applicationRepo}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'工事申請書_申請履歴詳細 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/constructions/:applyId/copy"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentConstructionAgreementPage
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'工事申請書_誓約同意 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/constructionComplete/input"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentConstructionCompleteInputPage
                    applicationRepo={applicationRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    holidaysRepo={holidaysRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'工事完了届_申請内容入力 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/constructionComplete/confirm"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentConstructionCompleteConfirmPage
                    applicationRepo={applicationRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'工事完了届_申請内容確認 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/constructionComplete/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentConstructionCompletePage
                    applicationRepo={applicationRepo}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'工事完了届_申請履歴詳細 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/constructionComplete/:applyId/copy"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentConstructionCompleteInputPage
                    applicationRepo={applicationRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    holidaysRepo={holidaysRepo}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'工事完了届_申請内容入力 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/windowFilmAttaches/agreement"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentWindowFilmAttachAgreementPage
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'窓ガラスフィルム貼付申請_誓約同意 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/windowFilmAttaches/input"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentWindowFilmAttachInputPage
                    applicationRepo={applicationRepo}
                    fileRepo={fileRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    holidaysRepo={holidaysRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'窓ガラスフィルム貼付申請_申請内容入力 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/windowFilmAttaches/confirm"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentWindowFilmAttachConfirmPage
                    applicationRepo={applicationRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'窓ガラスフィルム貼付申請_申請内容確認 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/windowFilmAttaches/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentWindowFilmAttachPage
                    applicationRepo={applicationRepo}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'窓ガラスフィルム貼付申請_申請履歴詳細 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/windowFilmAttaches/:applyId/copy"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentWindowFilmAttachAgreementPage
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'窓ガラスフィルム貼付申請_誓約同意 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/browses/agreement"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentBrowseAgreementPage
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'閲覧申請書_誓約同意 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/browses/input"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentBrowseApplyInputPage
                    applicationRepo={applicationRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    holidaysRepo={holidaysRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'閲覧申請書_申請内容入力 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/browses/confirm"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentBrowseConfirmPage
                    applicationRepo={applicationRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'閲覧申請書_申請内容確認 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/browses/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentBrowsePage
                    applicationRepo={applicationRepo}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'閲覧申請書_申請履歴詳細 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/browses/:applyId/copy"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentBrowseAgreementPage
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'閲覧申請書_誓約同意 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/longAbsence/input"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentLongAbsenceInputPage
                    applicationRepo={applicationRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    holidaysRepo={holidaysRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'長期不在届_申請内容入力 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/longAbsence/confirm"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentLongAbsenceConfirmPage
                    applicationRepo={applicationRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'長期不在届_申請内容確認 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/longAbsence/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentLongAbsencePage
                    applicationRepo={applicationRepo}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'長期不在届_申請履歴詳細 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/longAbsence/:applyId/copy"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentLongAbsenceInputPage
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId}
                    applicationRepo={applicationRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    holidaysRepo={holidaysRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'長期不在届_申請内容入力 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/heavyLoadsCarries/agreement"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentHeavyLoadsCarryAgreementPage
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'重量物搬入等届_誓約同意 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/heavyLoadsCarries/input"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentHeavyLoadsCarryInputPage
                    applicationRepo={applicationRepo}
                    fileRepo={fileRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    holidaysRepo={holidaysRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'重量物搬入等届_申請内容入力 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/heavyLoadsCarries/confirm"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentHeavyLoadsCarryConfirmPage
                    applicationRepo={applicationRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'重量物搬入等届_申請内容確認 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/heavyLoadsCarries/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentHeavyLoadsCarryPage
                    applicationRepo={applicationRepo}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'重量物搬入等届_申請履歴詳細 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/heavyLoadsCarries/:applyId/copy"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentHeavyLoadsCarryAgreementPage
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'重量物搬入等届_誓約同意 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/complete"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentApplicationCompletePage
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    eventEmitter={eventEmitter}
                    pageTitle={'届出・申請完了 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />


        <Route
            path="/resident/condominiums/:condominiumCd/account-transfer"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentAccountTransferPage
                    condominiumCd={props.params.condominiumCd!}
                    useFunctionMasterRepo={useFunctionMasterRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'口座振替の情報 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/account-transfer/info"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentBankAccountInfoPage
                    condominiumCd={props.params.condominiumCd!}
                    residentUserRepo={residentUserRepo}
                    bankAccountInfoRepo={bankAccountInfoRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'口座振替の情報 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/applications/account-transfer/receiving-agency/redirect"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentAccountTransferRedirectPage
                    navigate={props.navigate}
                    condominiumCd={props.params.condominiumCd!}
                    condominiumsRepo={condominiumsRepo}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'口座振替登録リダイレクト画面 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/assocs/selection"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentAssociationSelectionPage
                    condominiumCd={props.params.condominiumCd!}
                    assocWorkReportRepo={assocWorkReportRepo}
                    navigate={props.navigate}
                    eventEmitter={eventEmitter}
                    location={props.location}
                    pageTitle={'管理組合選択 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/assocs/:assocCd/work-Report"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentAssocWorkReportPage
                    condominiumCd={props.params.condominiumCd!}
                    assocCd={props.params.assocCd!}
                    assocWorkReportRepo={assocWorkReportRepo}
                    navigate={props.navigate}
                    currentDateTimeRepo={currentDateTimeRepo}
                    eventEmitter={eventEmitter}
                    pageTitle={'管理事務報告TOP | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/noAuthenticationKey/agreement"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentUserRegistrationAgreementPage
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'ユーザ登録申請_手続き説明画面 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/noAuthenticationKey/condominiumRegister"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentCondominiumRegisterPage
                    condominiumRepo={condominiumRepo}
                    tokenRepo={tokenRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'ユーザ登録申請_マンション・メールアドレス登録 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/noAuthenticationKey/mailSendComplete"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentUserRegistrationMailSendCompletePage
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'ユーザ登録申請_メール送信完了 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/noAuthenticationKey/residentUserRegister"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentNoAuthenticationKeyInputPage
                    tokenRepo={tokenRepo}
                    ridgeRepo={ridgeRepo}
                    applicationRepo={applicationRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'ユーザ登録申請_申請内容入力 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/noAuthenticationKey/residentUserConfirm"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentUserRegistrationConfirmPage
                    tokenRepo={tokenRepo}
                    applicationRepo={applicationRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'ユーザ登録申請_申請内容確認 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/noAuthenticationKey/complete"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentNoAuthenticationKeyCompletePage
                    navigate={props.navigate}
                    eventEmitter={eventEmitter}
                    location={props.location}
                    pageTitle={'ユーザ登録申請_申請提出完了 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/loginRedirectCushion"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentAfterLoginCushion
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    residentUserRepo={residentUserRepo}
                    roomToResidentRepo={roomToResidentRepo}
                    tokenRepo={tokenRepo}
                    adminAuthRepo={adminAuthRepo}
                    menuMasterRepo={menuMasterRepo}
                    sessionRepo={sessionRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    pageTitle={'ログインリダイレクトクッション | 素敵ネット'}/>
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/billingAmountConfirm"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentBillingAmountConfirmPage
                    condominiumCd={props.params.condominiumCd!}
                    residentUserRepo={residentUserRepo}
                    amountFixRepo={amountFixRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'管理費等お知らせ | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/billingAmountConfirm/receiptIssue"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentReceiptIssuePage
                    condominiumCd={props.params.condominiumCd!}
                    residentUserRepo={residentUserRepo}
                    amountFixRepo={amountFixRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'領収書発行 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/disasters/prevention/top"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentDisasterPreventionPage
                    condominiumCd={props.params.condominiumCd!}
                    residentUserRepo={residentUserRepo}
                    disasterRepo={disasterRepo}
                    navigate={props.navigate}
                    eventEmitter={eventEmitter}
                    pageTitle={'防災たすけあいTOP | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/disasters/mode/releaseExtension"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentDisasterModeReleaseExtensionPage
                    condominiumCd={props.params.condominiumCd!}
                    disasterRepo={disasterRepo}
                    navigate={props.navigate}
                    eventEmitter={eventEmitter}
                    pageTitle={'災害時モード解除・延長 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/disasters/topics"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentDisasterTopicListPage
                    key={'current'}
                    condominiumCd={props.params.condominiumCd!}
                    disasterRepo={disasterRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'災害時情報共有一覧｜素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/disasters/topics/past"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentDisasterTopicListPage
                    key={'past'}
                    condominiumCd={props.params.condominiumCd!}
                    disasterRepo={disasterRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    pastFlag={true}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'災害時情報共有一覧（過去）｜素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/disasters/mode/setting"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentDisasterModeSettingPage
                    condominiumCd={props.params.condominiumCd!}
                    disasterRepo={disasterRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    navigate={props.navigate}
                    eventEmitter={eventEmitter}
                    pageTitle={'災害時モード設定 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/disasters/mode/complete"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentDisasterModeSetupCompletePage
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'災害時モード設定完了 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/disasters/topics/register"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentDisasterTopicRegisterPage
                    condominiumCd={props.params.condominiumCd!}
                    disasterRepo={disasterRepo}
                    navigate={props.navigate}
                    eventEmitter={eventEmitter}
                    pageTitle={'トピック登録 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/disasters/topics/:topicId"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentDisasterTopicPage
                    key={'current'}
                    condominiumCd={props.params.condominiumCd!}
                    topicId={Number(props.params.topicId!)}
                    disasterRepo={disasterRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'トピック詳細 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/disasters/topics/:topicId/past"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentDisasterTopicPage
                    key={'past'}
                    pastFlag
                    condominiumCd={props.params.condominiumCd!}
                    topicId={Number(props.params.topicId!)}
                    disasterRepo={disasterRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'トピック詳細（過去） | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/disasters/topics/:topicId/edit"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentDisasterTopicEditPage
                    condominiumCd={props.params.condominiumCd!}
                    topicId={Number(props.params.topicId!)}
                    disasterRepo={disasterRepo}
                    navigate={props.navigate}
                    eventEmitter={eventEmitter}
                    pageTitle={'トピック編集 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/disasters/preventions"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentDisasterPreventionsPage
                    condominiumCd={props.params.condominiumCd!}
                    disasterRepo={disasterRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'防災情報一覧 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/resident/condominiums/:condominiumCd/disasters/preventions/:disasterPreventionId"
            element={<RouterPropsInjector>{(props) =>
                <NatResidentDisasterPreventionsDetailsPage
                    condominiumCd={props.params.condominiumCd!}
                    disasterPreventionId={Number(props.params.disasterPreventionId!)}
                    disasterRepo={disasterRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'防災情報詳細 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
    </>)
}
